// @generated by scripts/generate-graphql-cache-entity-resolver-schema.ts — do not edit.

export const entityResolverSchema = {
  CompleteMutationRoot: {
    markEmailThreadSeen: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
    recordChannelActivity: {
      targets: ['GraphqlChannelActivity'],
      argumentPaths: [['input', 'channelId']],
    },
    setEntityProperty: {
      targets: ['GraphqlProperty'],
      argumentPaths: [
        ['input', 'propertyDefinitionId'],
        ['input', 'value', 'entityReference', 'specificMessageId'],
        ['input', 'value', 'selectOption'],
      ],
    },
    updateEmailThreadLabel: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [
        ['input', 'labelId'],
        ['input', 'threadId'],
      ],
    },
  },
  GraphqlUser: {
    emailThread: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
  },
} as const;

export type GeneratedEntityResolverSchema = typeof entityResolverSchema;
export type GeneratedEntityResolverTarget =
  | 'GraphqlChannelActivity'
  | 'GraphqlProperty'
  | 'GraphqlSoupEmailThread';
export type GeneratedEntityResolverArgumentPath =
  | readonly ['input', 'channelId']
  | readonly ['input', 'labelId']
  | readonly ['input', 'propertyDefinitionId']
  | readonly ['input', 'threadId']
  | readonly ['input', 'value', 'entityReference', 'specificMessageId']
  | readonly ['input', 'value', 'selectOption'];
